module.exports = __webpack_public_path__ + "static/img/li4_1.55f0ddb5.png";